export const ORDERS_HISTORY_FEATURE_NAME = 'orders';

export const ORDER_DETAILS_DATE_FORMAT = 'd MMMM y, H:mm';
export const ORDER_DETAILS_GET_DOCUMENT_DATE_FORMAT = 'MMM dd, yyyy, HH:mm';

export const DEFAULT_ORDERS_LIST_LIMIT = 3;
export const DEFAULT_ORDERS_LIST_OFFSET = 0;

export const ACCORDIAN_EXPAND = 'expand';
export const ACCORDIAN_COLLAPS = 'collapse';
